import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

// Docs: https://vue3datepicker.com/props/formatting/
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("VueDatePicker", VueDatePicker);
});
